<template>
    <h3 class="mb-4 md:text-[26px] text-2xl font-semibold">
        <img src="../assets/images/logo-impuls-triangle-transparent.png" class="inline w-8 mr-3  mt-[-6px]" alt="" /> {{ title }}
    </h3>
    <p class="text-slate-400 max-w-xl mx-auto">{{ desc }}</p>
</template>

<script>
export default {
    data() {
        return {} 
    },
    props: ['title', 'desc']
}
</script>